import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const publishProducts = async ({ marketplaceId, body }) => {
  const path = `/marketplaces/${marketplaceId}/publish_products/`;
  try {
    const response = await axiosInstance.post(path, body);
    return response.data;
  } catch (error) {
    console.error('Publish Products API error:', error);
    throw error;
  }
};

export const usePublishProducts = (options = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: publishProducts,
    onSuccess: (data, variables) => {
      // Invalide le cache pour forcer un refetch des données
      queryClient.invalidateQueries({ queryKey: ['mpCatalogues'] });

      // Appelle le callback onSuccess personnalisé s'il existe
      options.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      options.onError?.(error, variables);
    },
    ...options,
  });

  return {
    publishProducts: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
  };
};
